var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SettlementCarReadinessCard',_vm._b({attrs:{"status":_vm.status,"status-color":_vm.statusColor,"completed":_vm.carReadinessDone,"dealer-name":_vm.settlement.dealer.name,"date":_vm.settlement.confirmedDelivery,"delivery-message":_vm.settlement.deliveryMessage,"is-mobile":_vm.$q.screen.xs}},'SettlementCarReadinessCard',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }